export class WebsocketEvent {
  topic: string;
  payload: any;

  constructor(topic: string, payload: any) {
    this.topic = topic;
    this.payload = payload;
  }
}


export class FollowInterventionWSE extends WebsocketEvent {
  constructor(imei: number) {
    super('FollowIntervention', imei);
  }
}

export class StopFollowInterventionWSE extends WebsocketEvent {
  constructor() {
    super('StopFollowIntervention', null);
  }
}

export class StartTransportInterventionsRealtimeWSE extends WebsocketEvent {
  constructor() {
    super('StartTransportInterventionsRealtime', null);
  }
}

export class StopTransportInterventionsRealtimeWSE extends WebsocketEvent {
  constructor() {
    super('StopTransportInterventionsRealtime', null);
  }
}
